// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
}
:host.color-temperature-slider ion-range {
  --bar-background-active: transparent;
  --knob-box-shadow: 0px 0.5px 4px rgba(0, 0, 0, 0.5), 0px 6px 13px rgba(0, 0, 0, 0.2);
}
:host.color-temperature-slider ion-range::part(knob) {
  --knob-size: 32px;
}
:host.hvac-mode ion-range {
  --bar-background-active: transparent;
}
:host.hvac-mode ion-range::part(knob) {
  background-color: var(--summerColor);
  --knob-size: 35px;
  --knob-box-shadow: 0;
}
:host.hvac-mode.isWinter ion-range::part(knob) {
  background-color: var(--winterColor);
}

.minmax {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--ion-color-medium-shade);
  font-weight: 600;
  margin-block-end: 4px;
  line-height: 1;
  width: calc(100% - 24px);
  margin-inline: 16px;
}
.minmax .center-number {
  margin-inline: 8px;
}
.minmax + ion-range {
  margin-inline: 16px;
}

.current-value {
  font-size: 24px;
  font-weight: 600;
  color: var(--ion-color-dark);
}

ion-range {
  --bar-height: 35px;
  --bar-border-radius: 10px;
  --bar-background: #f3f3f3;
  padding: 0 !important;
}

ion-icon {
  color: var(--ion-color-medium-shade);
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/draggable-slider/draggable-slider.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,MAAA;AACF;AAEI;EACE,oCAAA;EACA,oFAAA;AAAN;AAEM;EACE,iBAAA;AAAR;AAMI;EACE,oCAAA;AAJN;AAMM;EACE,oCAAA;EACA,iBAAA;EACA,oBAAA;AAJR;AASM;EACE,oCAAA;AAPR;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AAVF;AAYE;EACE,kBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AAZF;;AAeA;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAZF;;AAeA;EACE,oCAAA;AAZF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n\n  &.color-temperature-slider {\n    ion-range {\n      --bar-background-active: transparent;\n      --knob-box-shadow: 0px 0.5px 4px rgba(0, 0, 0, 0.5), 0px 6px 13px rgba(0, 0, 0, 0.2);\n\n      &::part(knob) {\n        --knob-size: 32px;\n      }\n    }\n  }\n\n  &.hvac-mode {\n    ion-range {\n      --bar-background-active: transparent;\n\n      &::part(knob) {\n        background-color: var(--summerColor);\n        --knob-size: 35px;\n        --knob-box-shadow: 0;\n      }\n    }\n\n    &.isWinter {\n      ion-range::part(knob) {\n        background-color: var(--winterColor);\n      }\n    }\n  }\n}\n\n.minmax {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--ion-color-medium-shade);\n  font-weight: 600;\n  margin-block-end: 4px;\n  line-height: 1;\n  width: calc(100% - 24px);\n  margin-inline: 16px;\n\n  .center-number {\n    margin-inline: 8px;\n  }\n\n  &+ion-range {\n    margin-inline: 16px;\n  }\n}\n\n.current-value {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--ion-color-dark);\n}\n\nion-range {\n  --bar-height: 35px;\n  --bar-border-radius: 10px;\n  --bar-background: #f3f3f3;\n  padding: 0 !important;\n}\n\nion-icon {\n  color: var(--ion-color-medium-shade);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
